module.exports = __webpack_public_path__ + "img/noble-level0-img.3c1fe695.png";